import { withTheme } from '../Themes';

import withJson from './HOC/withJSON';
import TimeLine from './Timeline';
import StepStatuses from './Utils/StepStatuses';
import { TimelineEvents } from './Utils/TimelineEvents';

const DynamicTimeLine = withTheme(withJson(TimeLine));

export { StepStatuses, DynamicTimeLine, TimelineEvents };

export default TimeLine;
